// import stripe from 'stripe';
// const stripe = require('@stripe/stripe-js')('sk_test_ko1Hp1CX04FKgXaIS0apbeGj00shEk58oU');
import { Elements } from '@stripe/react-stripe-js';
import ClassCheckout from 'components/ClassCheckout';
import ClassConfirmation from 'components/ClassConfirmation';
import ClassList from 'components/ClassList';
import React, { useEffect, useState } from "react";
import {useSelector, useDispatch } from 'react-redux'
import { getOfferingCheckout } from 'util/api/CheckoutAPI';
import { useLocation } from "react-router-dom";
// import AsyncStripeProvider from 'util/AsyncStripeProvider';
import { StripeProvider } from 'react-stripe-elements';
import { Route, Switch, useRouter } from "util/router.js";
import ClassWidget from 'pages/classWidget'
import PricingWidget from 'pages/PricingWidget'
import OnDemandWidget from 'components/OnDemandWidget'
import ChallengeWidgetNav from 'components/Challenges/ChallengeWidgetNav'
import {fetchOndemand} from 'store/actions/widgetActions'
import {useChallenge} from 'util/challengeWidgetProvider'
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser(); 
// import "./classWidget.scss";

// / A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}



function ChallengePageWidget(props) {
    const { match, stripe, challengeid } = props;
    
    const challengeWidget = useChallenge()
    const selectedChallenge = challengeWidget?.challenge

    const challengeWidgetIndex = () => {
        if (props.location.pathname.includes("on-demand")) {
            return 1
        } else if (props.location.pathname.includes("resources")) {
            return 2
        }
        return 0
    }

    return (
    <>
        {selectedChallenge?.id === '39RMMwzetXOAFnWhI2VD' && (
            <img src="https://via.placeholder.com/1600x800.jpg" alt="Nature" style={{width: "100%", height: "auto"}} /> 
        )}
        {selectedChallenge && selectedChallenge.bulletinBoardBodyHTML && (
            htmlToReactParser.parse(selectedChallenge.bulletinBoardBodyHTML)
        )}

        {['if0SRWWsxyoUd9CPuPtO', '7ZaGJpAye0x2ZE0K9ddi','mhoHmXZ84BJsnXIs1WyS','4nfgrMaWKAbqbrDZMNiT','3eyDT2jXyGWZBvs42iwY', '0iQJCmoK4MjFhKzvaUBn', 'eTCw1h46AyX5E8QIISdx', 'UuGa0i57Gh6BQ67VwHcD', 'yy6uYWn5CzhaK6IyYkdS', 'iXzRuAmD65MK5O48wB8d'].includes(selectedChallenge?.id ?? "") ? ( // albina challenge
            <>
            <ChallengeWidgetNav show={true} url={`${match.url}`} selectedIndex={challengeWidgetIndex()} />
            <Switch>
                <Route 
                    path={`${match.url}/resources`}
                    render={props => {
                        return  (<>
                            <OnDemandWidget products={true} challengeid={challengeid} stripe={stripe} {...props} />
                        </>)
                    }} 
                />
                <Route 
                    path={`${match.url}/on-demand`}
                    render={props => {
                        return  (<>
                            <OnDemandWidget ondemand={true} challengeid={challengeid} stripe={stripe} {...props} />
                        </>)
                    }} 
                />
                <Route
                    path={`${match.url}`}
                    render={props => {
                        return (<>
                            {/* <Redirect to={`${match.url}/on-demand`} /> */}
                            <OnDemandWidget ondemand={true} challengeid={challengeid} stripe={stripe} {...props} />
                        </>)
                    }}>
                    
                </Route>
            </Switch>
            </>
        ) : (
            <>
            {[].includes(selectedChallenge?.id ?? "") ? (<>
                <ChallengeWidgetNav show={true} url={`${match.url}`} selectedIndex={challengeWidgetIndex()} />
                <Switch>
                    <Route 
                        path={`${match.url}/resources`}
                        render={props => {
                            return  (<>
                                <OnDemandWidget products={true} challengeid={challengeid} stripe={stripe} {...props} />
                            </>)
                        }} 
                    />
                    <Route 
                        path={`${match.url}/on-demand`}
                        render={props => {
                            return  (<>
                                <OnDemandWidget products={true} challengeid={challengeid} stripe={stripe} {...props} />
                            </>)
                        }} 
                    />
                    <Route
                        path={`${match.url}`}
                        render={props => {
                            return (<>
                                <ClassWidget challengeid={challengeid} stripe={stripe} {...props}/>
                            </>)
                        }}>
                        
                    </Route>
                </Switch>
            </>) : (<> 
                {["sJDuOkbka1phBFjybEEU"].includes(selectedChallenge?.id ?? "") ? (<>
                    <OnDemandWidget products={true} challengeid={challengeid} stripe={stripe} {...props} />
                </>) : (<>
                
                    <ChallengeWidgetNav show={true} url={`${match.url}`} selectedIndex={challengeWidgetIndex()} />
                    <Switch>
                        <Route 
                            path={`${match.url}/resources`}
                            render={props => {
                                return  (<>
                                    <OnDemandWidget products={true} challengeid={challengeid} stripe={stripe} {...props} />
                                </>)
                            }} 
                        />
                        <Route 
                            path={`${match.url}/on-demand`}
                            render={props => {
                                return  (<>
                                    <OnDemandWidget ondemand={true} challengeid={challengeid} stripe={stripe} {...props} />
                                </>)
                            }} 
                        />
                        <Route
                            path={`${match.url}`}
                            render={props => {
                                return (<>
                                    <ClassWidget challengeid={challengeid} stripe={stripe} {...props}/>
                                </>)
                            }}>
                            
                        </Route>
                    </Switch>
                </>)}
            </>)}
            </>
        )}
    </>
    )
}

export default ChallengePageWidget;